import React, { useEffect, useState } from "react";
import "./faq.scss";
import axios from "axios";
import { BASE } from "../../App";
import Loading from "../loading/Loading";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Faq = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [catIndex, setCatIndex] = useState(0);
  const [innerCat, setInnerCat] = useState(0);
  const [qIndex, setQindex] = useState(0);
  const [title, setTitle] = useState("");
  const [pr, setPr] = useState("");

  const handleCategory = (index) => {
    if (index === catIndex) {
      setCatIndex(-1);
      setInnerCat(-1);
      setQindex(-1);
    } else {
      setCatIndex(index);
      setInnerCat(-1);
      setQindex(-1);
    }
  };
  const handleInnerCat = (index) => {
    if (index === innerCat) {
      setInnerCat(-1);
      setQindex(-1);
    } else {
      setInnerCat(index);
      setQindex(-1);
    }
  };
  const handleQ = (index) => {
    if (index === qIndex) {
      setQindex(-1);
    } else {
      setQindex(index);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(BASE + "/faq");
        const data = res.data.data.faqs;
        setTitle(res.data.data.faq_page.header);
        setPr(res.data.data.faq_page.paragraph);
        const arrF = [];
        for (let i = 0; i < data.length; i++) {
          const category = arrF.find(
            (item) => item.category === data[i].product.category.sub_category
          );
          if (!category) {
            arrF.push({
              category: data[i].product.category.sub_category,
              sub: [
                {
                  inner: data[i].product.title,
                  q2: [{ quset: data[i].question, ans: data[i].answer }],
                },
              ],
            });
          } else {
            const sub = category.sub.find(
              (inner) => inner.inner === data[i].product.title
            );
            if (!sub) {
              const subObject = {
                inner: data[i].product.title,
                q2: [{ quset: data[i].question, ans: data[i].answer }],
              };
              category.sub.push(subObject);
            } else {
              sub.q2.push({ quset: data[i].question, ans: data[i].answer });
            }
          }
        }
        setData(arrF);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const cats = data.map((item) => {
    return item.category;
  });
  return (
    <>
      {!loading ? (
        <>
        
          <div className="faq_container">
            <div className="Faqs_hero">
              <h1>Trade Finance FAQs</h1>
              <h2>Clear Answers to Common Trade Finance Questions</h2>
              <p>
               At TradeFlair, we provide clear answers to frequently asked questions on trade finance solutions, helping businesses 
               make informed decisions. Explore FAQs covering import finance, export finance, Buyer's Credit, Letters of Credit, 
               and LC bill discounting to understand processes, documentation, and execution with confidence.
              </p>
            </div>
            <div className="faq_text faq_tex_new_aft">
              <h2>{title}</h2>
              <p>{pr}</p>
            </div>
            <div className="faq_map">
              <div className="faq_top">
                {cats.map((item, index) => (
                  <h2
                        className={`faq_top_item ${
                          index === catIndex && "faq_top_item_active"
                        }`}
                        onClick={() => handleCategory(index)}
                      >
                        {item}
                        <span className="arrow">
                          {index === catIndex ? <FaChevronUp /> : <FaChevronDown />}
                        </span>
                    </h2>

                ))}
              </div>
              <div className="faq_bottom">
                {data.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`faq_item ${
                        catIndex !== index && "display_none"
                      }`}
                    >
                      <div className="faq_category wraper_1">
                        <h2 className="expand_1 faq_top_inner">
                          {item.category}
                        </h2>
                        <div className="faq_inner">
                          {item.sub.map((sub, i) => {
                            return (
                              <div key={i}>
                                <h3
                                  className={`sub_category ${
                                    innerCat === i && "faq_aqtive_color"
                                  }`}
                                  onClick={() => handleInnerCat(i)}
                                >
                                  {sub.inner}
                                  <span className="arrow">
                                    {innerCat === i ? <FaChevronUp /> : <FaChevronDown />}
                                  </span>
                                </h3>


                                {innerCat === i &&
                                  sub.q2.map((q, qIn) => {
                                    return (
                                      <div
                                        className="faq_q_container"
                                        key={qIn}
                                      >
                                       <h4
                                          className={`${qIndex === qIn && "faq_aqtive_color"}`}
                                          onClick={() => handleQ(qIn)}
                                        >
                                          {q.quset}
                                          <span className="arrow">
                                            {qIndex === qIn ? <FaChevronUp /> : <FaChevronDown />}
                                          </span>
                                        </h4>
                                        {qIn === qIndex && <p>{q.ans}</p>}
                                      </div>
                                    );
                                  })}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="faq_mobile">
            {data.map((item, index) => {
              return (
                <div className="faq_item_mobile" key={index}>
                  <h3
                    className={`faq_top_item_mobile ${
                      index === catIndex && "faq_top_item_active_mobile"
                    }`}
                    onClick={() => handleCategory(index)}
                  >
                    {item.category}
                  </h3>
                  <div className="faq_mobile_sub">
                    {catIndex === index ? (
                      <>
                        {item.sub.map((subItem, i) => {
                          return (
                            <div key={i}>
                              <h4
                                className={`sub_category ${
                                  innerCat === i && "faq_aqtive_color"
                                }`}
                                onClick={() => handleInnerCat(i)}
                              >
                                {subItem.inner}
                              </h4>
                              {innerCat === i ? (
                                <>
                                  <div className="faq_mobile_quest">
                                    {subItem.q2.map((q, qI) => {
                                      return (
                                        <div key={qI}>
                                          <h4
                                            className={`${
                                              qIndex === qI &&
                                              "faq_aqtive_color"
                                            }`}
                                            onClick={() => handleQ(qI)}
                                          >
                                            {q.quset}
                                          </h4>
                                          {qI === qIndex && <p>{q.ans}</p>}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <Loading title={"F.A.Q"} />
      )}
    </>
  );
};

export default Faq;
